<form
  [formGroup]="form"
  (submit)="onSubmit($event)"
  xmlns="http://www.w3.org/1999/html"
>
  <div class="modal-body d-flex justify-content-between">
    <div class="form-section">
      <div class="form-group">
        <label for="account-display-name" class="form-control-label">
          Display Name *
        </label>
        <input
          name="account-display-name"
          type="text"
          class="form-control"
          placeholder="E.g. Account 1"
          formControlName="accountDisplayName"
        />

        <div
          *ngIf="
            submitted ||
            (accountDisplayName.invalid &&
              (accountDisplayName.dirty || accountDisplayName.touched))
          "
          class="form-control-feedback text-danger"
        >
          <small *ngIf="accountDisplayName.hasError('required')">
            Account display name is required
          </small>
          <small *ngIf="accountDisplayName.hasError('minlength')">
            Account display name must be at least 3 characters
          </small>
          <small *ngIf="accountDisplayName.hasError('maxlength')">
            Account display name must not exceed 32 characters
          </small>
        </div>
      </div>

      <div class="form-group account-id">
        <label for="account-id" class="form-control-label"
          >Account ID (auto generated)</label
        >
        <input
          name="account-id"
          type="text"
          class="form-control"
          formControlName="accountId"
          disabled
        />
        <div class="clipboard" [cdkCopyToClipboard]="accountId.value">
          <i class="fa fa-clipboard"></i><span>Copy the account ID</span>
        </div>
      </div>

      <div class="form-group">
        <label for="account-category">Category *</label>
        <select
          class="form-control"
          id="account-category"
          formControlName="accountCategory"
        >
          <option
            *ngFor="let category of accountCategories"
            [value]="category.code"
          >
            {{ category.displayName }}
          </option>
        </select>
      </div>

      <div *ngIf="hasSubscriptionId" class="form-group">
        <label for="subscription-id" class="form-control-label"
          >Subscription Id<span
            *ngIf="accountCategory?.value !== AccountCategoryCode.Trial"
          >
            *</span
          ></label
        >
        <input
          name="subscription-id"
          type="text"
          class="form-control"
          maxLength="17"
          formControlName="subscriptionId"
        />
        <div
          *ngIf="
            submitted ||
            (subscriptionId.invalid &&
              (subscriptionId.dirty || subscriptionId.touched))
          "
          class="form-control-feedback text-danger"
        >
          <small *ngIf="subscriptionId.hasError('required')">
            Subscription ID is required for non-Trial accounts
          </small>
          <small *ngIf="subscriptionId.hasError('pattern')">
            Subscription Id is invalid. It should have 16 alphanumeric
            characters
          </small>
        </div>
      </div>

      <div class="form-group">
        <div>
          <label class="form-control-label" for="audience-package">
            Number of profiles (0 below means unlimited) *
          </label>
          <input
            type="number"
            name="audience-package"
            class="form-control"
            placeholder="Number of profiles"
            formControlName="packageSize"
          />
          <div
            *ngIf="
              submitted ||
              (packageSize.invalid &&
                (packageSize.dirty || packageSize.touched))
            "
            class="form-control-feedback text-danger"
          >
            <small *ngIf="packageSize.hasError('required')">
              Field is required
            </small>
            <small *ngIf="packageSize.hasError('max')"> Too large value </small>
            <small *ngIf="packageSize.hasError('min')">
              Number of profiles can't be less than zero
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="form-group">
        <label for="order-number" class="form-control-label">
          Order Number *
        </label>
        <input
          type="text"
          name="order-number"
          class="form-control"
          maxLength="17"
          placeholder="Order number (16 alphanumeric characters)"
          formControlName="orderNumber"
        />
        <div
          *ngIf="
            submitted ||
            (orderNumber.invalid && (orderNumber.dirty || orderNumber.touched))
          "
          class="form-control-feedback text-danger"
        >
          <small *ngIf="orderNumber.hasError('required')">
            Order number is required
          </small>
          <small *ngIf="orderNumber.hasError('pattern')">
            Order number is invalid. It should have 16 alphanumeric characters
          </small>
        </div>
      </div>

      <div class="form-group">
        <label for="account-description" class="form-control-label">
          Description
        </label>
        <textarea
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          name="account-description"
          class="form-control"
          placeholder="Additional info (internal use only)"
          formControlName="accountDescription"
        ></textarea>

        <div
          *ngIf="
            submitted ||
            (accountDescription.invalid &&
              (accountDescription.dirty || accountDescription.touched))
          "
          class="form-control-feedback text-danger"
        >
          <small *ngIf="accountDescription.hasError('maxlength')">
            Account description must not exceed 1000 characters
          </small>
        </div>
      </div>

      <div class="form-group">
        <label for="admin-email" class="form-control-label">
          Account owner email *
        </label>

        <input
          name="admin-email"
          type="text"
          class="form-control"
          placeholder="Account Owner email"
          formControlName="adminEmail"
        />

        <div
          *ngIf="
            state === formStates.submitting ||
            (adminEmail.invalid && (adminEmail.dirty || adminEmail.touched))
          "
          class="form-control-feedback text-danger"
        >
          <small *ngIf="adminEmail.hasError('required')">
            You have to invite an Account Owner
          </small>

          <small *ngIf="adminEmail.hasError('pattern')">
            Email address is invalid
          </small>

          <small *ngIf="adminEmail.hasError('email')">
            This is not a valid email address
          </small>
        </div>
      </div>

      <div class="form-group from-domains">
        <label class="form-control-label from-domain-title">
          Allowed from domains<span *ngIf="!isTrialCategory"> *</span>
          <span class="from-domain-subtitle">(sender email)</span>
        </label>
        <ng-container formArrayName="fromDomains">
          <div
            *ngFor="let domain of fromDomains.controls; let i = index"
            class="from-domain-row"
          >
            <div class="from-domain-input-group">
              <input
                type="text"
                class="form-control"
                placeholder="example.com"
                [formControlName]="i"
                [attr.aria-label]="'From domain ' + (i + 1)"
              />
              <button
                type="button"
                class="btn btn-danger from-domain-remove"
                (click)="removeFromDomain(i)"
                [disabled]="fromDomains.length <= 1 && !domain.value"
                [attr.aria-label]="'Remove from domain ' + (i + 1)"
              >
                Remove
              </button>
            </div>

            <div
              *ngIf="
                (submitted || domain.dirty || domain.touched) &&
                domain.hasError('invalidDomainFormat')
              "
              class="form-control-feedback text-danger from-domain-error"
            >
              <small>Enter a valid domain (e.g. example.com)</small>
            </div>
          </div>
        </ng-container>

        <button
          type="button"
          class="btn btn-success from-domain-add"
          (click)="addFromDomain()"
        >
          <i class="fa fa-plus"></i> Add another
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="container">
      <div class="row no-gutters">
        <div class="col">
          <div class="deprecation">
            <span
              ><i class="fa fa-info-circle"></i> New license packages 2025
              <br />
              <i>Lite</i>, <i>Essential</i> and <i>All in one</i> are
              deprecated. Use <i>Send</i>, <i>Automate</i> and
              <i>Grow</i> instead, respectively.</span
            >
          </div>
          <label class="form-control-label">Choose license package</label>
          <ng-container *ngIf="!licensePackagesError; else packageError">
            <app-loading-spinner *ngIf="isLoadingPackages; else packages">
              Loading packages...
            </app-loading-spinner>
            <ng-template #packages>
              <div class="row">
                <div class="col-auto" *ngFor="let package of licensePackages">
                  <app-account-package
                    [ngClass]="{ disabled: package.disabled }"
                    [package]="package.displayName"
                    [licenses]="package.licenses"
                    [innerId]="package.code + 'Package'"
                    [selected]="licensePackage === package.code"
                    (click)="clickPackage(package.code)"
                  >
                  </app-account-package>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #packageError> Could not fetch packages </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-auto ml-auto align-self-end">
          <button
            type="button"
            id="button_createaccount_cancel"
            class="btn btn-outline-dark margin-right"
            (click)="activeModal.close('Close click')"
          >
            Cancel
          </button>
          <button
            type="button"
            id="button_createaccount_confirm"
            type="submit"
            class="btn btn-success"
            [disabled]="
              state === formStates.submitting ||
              form.invalid ||
              licensePackagesError
            "
          >
            Create account <i class="far fa-arrow-alt-circle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<div *ngIf="state === formStates.submitting" class="loading-spinner">
  <app-loading-spinner></app-loading-spinner>
</div>
